export default "__VITE_ASSET__jG7HfXQn__";